import styled from '@emotion/styled';
import { Card } from 'antd';

export const AuthCard = styled(Card)({
  width: '31.25rem',

  '& .ant-card-body': {
    padding: '3rem',
  },
});
